import { BAND_LOOK } from "@/components/wellbeing/who5";

// Draws a share image with only the band (no score, no answers)
export const resultCardBlob = (band, label) => new Promise((resolve, reject) => {
  const look = BAND_LOOK[band];
  const c = document.createElement("canvas");
  c.width = c.height = 1080;
  const x = c.getContext("2d");
  const font = getComputedStyle(document.body).fontFamily || "sans-serif";
  x.fillStyle = "#F8F5FC"; x.fillRect(0, 0, 1080, 1080);
  x.fillStyle = look.bg; x.beginPath(); x.roundRect(80, 80, 920, 920, 64); x.fill();
  x.textAlign = "center"; x.textBaseline = "middle";
  x.fillStyle = look.ink; x.font = `600 40px ${font}`; x.fillText("How am I really doing?", 540, 230);
  x.font = `220px ${font}`; x.fillText(look.emoji, 540, 470);
  x.font = `bold 96px ${font}`; x.fillText(label, 540, 680, 840);
  x.font = `38px ${font}`; x.globalAlpha = 0.75; x.fillText("My 2-minute wellbeing check", 540, 780);
  x.globalAlpha = 1; x.fillStyle = "#7C5CBF"; x.font = `600 34px ${font}`; x.fillText("mindfulmeyourcalmcompanion.com/wellbeing-check", 540, 920, 860);
  c.toBlob((b) => (b ? resolve(b) : reject(new Error("Couldn't create the image"))), "image/png");
});
